import { useEffect, useState } from 'react';

/**
 * Custom hook to detect if the application is running in an iOS WebView
 * @returns boolean indicating if the app is running in an iOS WebView
 */
export const useIsIOSWebView = (): boolean => {
  const [isIOSWebView, setIsIOSWebView] = useState<boolean>(false);

  useEffect(() => {
    const detectIOSWebView = (): boolean => {
      const userAgent = navigator.userAgent;
      const isIOS = /iPad|iPhone|iPod/.test(userAgent);

      if (!isIOS) {
        return false;
      }

      // Check for explicit WKWebView indicator (like "GoogleWv/1.0 (WKWebView)")
      if (/WKWebView/i.test(userAgent)) {
        return true;
      }

      // Check for Safari - if Safari is NOT present in the user agent, it's likely a WebView
      const isSafari = /Safari/.test(userAgent);
      const isWebKit = /WebKit/.test(userAgent);

      // In-app browsers and WebViews typically don't have "Safari" in the user agent
      // but have "WebKit"
      const isWebView = isWebKit && !isSafari;

      // Additional check for WKWebView message handlers
      const hasWKWebView =
        (window as any).webkit?.messageHandlers !== undefined;

      return isWebView || hasWKWebView;
    };

    setIsIOSWebView(detectIOSWebView());
  }, []);

  return isIOSWebView;
};
